import i18n from "i18next";

export default function Modules({props, modules}) {
    const convertExpirationDate = dateToConvert => {
        let date = new Date(dateToConvert);
        let getMonth = date.toLocaleString('default', {
            month: 'long'
        });
        let convertedDate = getMonth + ' ' + date.getDay() + ', ' + date.getFullYear();
        console.log(convertedDate);
    }

    return (
        <div className="manage-subscriptions-modules-container">
            {modules.map((module, key) =>
                <div className="module" key={key}>
                    <div className="module-icon-name-container">
                        <span className="module-icon" dangerouslySetInnerHTML={{__html: module["icon"]}} />
                        <span className="module-name">{module.sales_name ?? module.name}</span>
                    </div>
                    <div className="module-price-status-container">
                        <span className="module-price">${module.price}
                            {module["billing_frequency"] === "monthly" ?
                                i18n.t("admin-account-overview.manage-subscriptions-modal./mo") :
                                i18n.t("admin-account-overview.manage-subscriptions-modal./yr")}
                        </span>
                        {/*{module.trial && <span */}
                        {/*    className="module-status-info">Trial Expires {convertExpirationDate(module.trial.expires_on)}</span>*/}
                        {/*}*/}
                        {/*<span className="far fa-chevron-right" />*/}
                    </div>
                </div>
            )}
        </div>
    )
}
